export default function HowItWorks() {
  const steps = [
    {
      number: '01',
      title: 'Identify Critical Components',
      description: 'Map 10–20 SKUs most tied to downtime and expediting',
      details: ['Component risk assessment', 'Downtime impact analysis', 'Priority SKU mapping']
    },
    {
      number: '02',
      title: 'Assess Readiness Gaps',
      description: 'Document location, response expectations, and handoff friction points',
      details: ['Current state analysis', 'Handoff documentation', 'Gap identification']
    },
    {
      number: '03',
      title: 'Coordinate & Track',
      description: 'Monitor readiness signals and define ownership across parties',
      details: ['Real-time monitoring', 'Ownership assignment', 'Signal tracking']
    },
    {
      number: '04',
      title: 'Deliver Monthly Reporting',
      description: 'Provide clear visibility dashboards and response summaries',
      details: ['Performance dashboards', 'SLA reporting', 'Actionable insights']
    }
  ];

  return (
    <section id="how-it-works" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center space-x-2 mb-4">
            <div className="w-2 h-2 bg-[#0A5F5C] rounded-full"></div>
            <span className="text-[#0A5F5C] font-semibold text-sm uppercase tracking-wider">Process</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2332]">
            How It Works
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-full w-full h-0.5 border-t-2 border-dashed border-[#0A5F5C]/30 -translate-x-4"></div>
              )}
              
              <div className="relative z-10">
                <div className="w-20 h-20 bg-gradient-to-br from-[#0A5F5C] to-[#0D7A76] rounded-full flex items-center justify-center mb-6 mx-auto shadow-lg">
                  <span className="text-2xl font-bold text-white">{step.number}</span>
                </div>
                
                <h3 className="text-xl font-bold text-[#1A2332] mb-3 text-center">
                  {step.title}
                </h3>
                
                <p className="text-[#5A6670] leading-relaxed mb-4 text-center">
                  {step.description}
                </p>
                
                <ul className="space-y-2">
                  {step.details.map((detail, idx) => (
                    <li key={idx} className="flex items-start space-x-2 text-sm text-[#5A6670]">
                      <i className="ri-check-line text-[#0A5F5C] mt-0.5 flex-shrink-0"></i>
                      <span>{detail}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
